
const now = new Date();
export const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

export type OptionContract = {
  id: string;
  optionId: string;
  optionName: string;
  status: boolean;
  applicableStartDate: Date | null;
  applicableFinishDate: Date | null;
  sort?: number;
};

export const optionContractTimestampToDate = (data: any | undefined): OptionContract => {
  if(data.applicableStartDate !== null){
    const startDate = new Date(data.applicableStartDate.seconds * 1000);
    data.applicableStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  }
  if(data.applicableFinishDate !== null){
    const finishDate = new Date(data.applicableFinishDate.seconds * 1000);
    data.applicableFinishDate = new Date(finishDate.getFullYear(), finishDate.getMonth(), finishDate.getDate());
  }
  return data;
};